module.exports = __webpack_public_path__ + "static/media/proactive_parenting_tip_bag.0427d1f3.png";